import { ReactElement } from "react";
import Layout from "../../../components/layout";
import HubBrands from "../../../components/Hubs/Brands/index";

const HubBrandPage = (): ReactElement => {
  return (
    <Layout>
      <HubBrands />
    </Layout>
  );
};

export default HubBrandPage;
